/* Clones the rendered block list so the -50% loop has a second copy to wrap onto.
   See docs/theme-architecture/sections/text-marquee.md. */

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

class TextMarquee extends HTMLElement {
  connectedCallback() {
    this.motionQuery = window.matchMedia(REDUCED_MOTION);
    this.onMotionChange = () => this.build();
    this.motionQuery.addEventListener('change', this.onMotionChange);
    this.build();
  }

  disconnectedCallback() {
    this.motionQuery?.removeEventListener('change', this.onMotionChange);
  }

  build() {
    const track = this.querySelector('.text-marquee__track');
    const source = track?.querySelector('.text-marquee__copy:not([data-marquee-clone])');
    if (!track || !source) return;

    try {
      track.querySelectorAll('[data-marquee-clone]').forEach((el) => el.remove());

      if (this.motionQuery.matches || source.children.length === 0) {
        this.setAttribute('data-mode', 'static');
        return;
      }
      this.removeAttribute('data-mode');
      track.appendChild(this.duplicate(source));
    } finally {
      this.setAttribute('data-ready', '');
    }
  }

  duplicate(source) {
    const clone = source.cloneNode(true);
    clone.setAttribute('data-marquee-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    // Strip what has to stay unique to the real copy, and take the clone out of the tab
    // order — focusable content inside aria-hidden is its own a11y failure.
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    clone
      .querySelectorAll('[data-shopify-editor-block]')
      .forEach((el) => el.removeAttribute('data-shopify-editor-block'));
    clone
      .querySelectorAll('a, button, input, select, textarea, [tabindex]')
      .forEach((el) => el.setAttribute('tabindex', '-1'));
    return clone;
  }
}

if (!customElements.get('text-marquee')) {
  customElements.define('text-marquee', TextMarquee);
}
